module.exports = __webpack_public_path__ + "static/paytm_logo-cb839c9498e7a4a410965031b6f9bb86.png";